import { Form } from 'antd';

import styles from './AppForm.module.scss';

const renderRequiredMark = (label, { required }) => (
  <>
    {label}
    <span className='color-danger'>{required ? '*' : ''}</span>
  </>
);

export function AppForm({ form, onFinishFailed, children, className = '', ...restProps }) {
  const onFinishFailedInnerFunc = (values) => {
    form.scrollToField(values.errorFields[0].name, {
      behavior: 'smooth',
      block: 'start', // or 'center', 'end', 'nearest'
      inline: 'nearest',
      focus: true, // focus the field
    });
    onFinishFailed?.(values);
  };

  return (
    <Form
      form={form}
      labelCol={{ span: 6 }}
      onFinishFailed={onFinishFailedInnerFunc}
      autoComplete='off'
      requiredMark={renderRequiredMark}
      colon={false}
      layout='vertical'
      className={`${styles.appForm} ${className}`}
      {...restProps}
    >
      {children}
    </Form>
  );
}

const AppFormItem = ({ children, className = '', ...restProps }) => (
  <Form.Item className={className} {...restProps}>
    {children}
  </Form.Item>
);

AppForm.Item = AppFormItem;
